import loadable from '@loadable/component';

const SearchPage = loadable(() => import('./SearchPage'));

export { SearchPage };
